import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import { Card, Table, Button, Modal } from 'antd';
import Lottie from 'lottie-react';
import ReactSpeedometer from 'react-d3-speedometer';

export const XThemeLottie = styled(Lottie)`
	position: relative;
	background: transparent;
	width: 100%;
`;
export const XThemeCardTitle1 = styled.h1`
	font-family: ${({ theme }) => theme.colors.fontPoppins} !important;
	width: 100%;
	position: relative;
	margin: 0px;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.themeColor4};
	&.fontSize24 {
		font-weight: 400;
		font-size: 16px;
		line-height: 24px;
		color: ${({ theme }) => theme.colors.themeColor1};
		opacity: 0.8;
	}
	@media only screen and (max-width: 768px) {
	}
`;
export const XThemeCardTitle2 = styled.h1`
	width: 100%;
	position: relative;
	margin: 0px;
	font-weight: 600;
	font-size: 24px;
	line-height: 20px;
	&.textColor1 {
		color: ${({ theme }) => theme.colors.themeColor13};
	}
	&.textColor2 {
		color: ${({ theme }) => theme.colors.themeColor7};
	}
	&.textColor3 {
		color: ${({ theme }) => theme.colors.themeColor12};
	}
	&.textColor4 {
		color: ${({ theme }) => theme.colors.themeColor30};
	}
	&.textColor5 {
		color: ${({ theme }) => theme.colors.themeColor16};
	}
	&.textColor6 {
		color: ${({ theme }) => theme.colors.themeColor17};
	}
	&.textColor7 {
		color: ${({ theme }) => theme.colors.themeColor31};
	}
	&.fontSize30 {
		font-weight: 600;
		font-size: 30px;
		line-height: 24px;
	}
	@media only screen and (max-width: 768.99px) {
	}
`;
export const XThemeCardTitle3 = styled.h1`
	width: 100%;
	position: relative;
	margin: 0px;
	font-weight: 600;
	font-size: 20px;
	line-height: 32px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.colors.white};
	@media only screen and (max-width: 768.99px) {
	}
`;
export const XThemeCaseCard = styled(Card)`
	width: 100%;
	position: relative;
	height: 100%;
	background-image: url('../images/theme-case-card.svg'),
		linear-gradient(
			to right,
			${({ theme }) => theme.colors.themeColor8},
			${({ theme }) => theme.colors.themeColor25}
		);
	background-size: cover;
	border-radius: 20px;
	@media only screen and (max-width: 768.99px) {
	}
	a {
		color: #fff;
	}
`;
export const XThemeSwitch = styled.div`
	width: 100%;
	position: relative;
	background: #ffffff;
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 25px;
	padding: 10px 5px;
	font-weight: 500;
	font-size: 11px;
	line-height: 16px;
	color: #081d16;
	text-align: center;
	button.ant-switch-checked {
		background: #000 !important;
	}
	@media only screen and (max-width: 991.99px) {
		&.mobileDashboardView {
			width: 80%;
		}
	}
`;
export const XThemeStatisticsCard = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 20px;
	&.noPadding {
		.ant-card-body {
			padding: 24px 0px;
		}
	}
	.cardPadding {
		width: 100%;
		position: relative;
		padding: 0px 24px;
	}
	@media only screen and (max-width: 991.99px) {
		&.mobileFancyCard {
			border-radius: 20px;
			border-style: solid;
			border-color: ${({ theme }) => theme.colors.themeColor22};
			border-width: 0px 0px 1px 1px;
			background: #ffffff url(../images/fancy-card-right.png) no-repeat
				right top;
		}
	}
	.fancyCardInfoCustom {
		display: none;
		@media only screen and (max-width: 991.99px) {
			display: block;
			position: absolute;
			text-align: center;
			top: 7px;
			right: 10px;
			width: 50px;
			height: 50px;
			line-height: 40px;
			border-radius: 50px;
			z-index: 1;
			img {
				margin-top: -5px;
			}
		}
	}
`;
export const XThemeStatisticsGraphCard = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor23};
	border-radius: 20px;
	h1.cardTitle {
		margin: 0px;
		font-weight: 500;
		font-size: 16px;
		line-height: 32px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor2};
	}
	/* .ant-card-body {
		padding: 18px 30px !important;
		@media only screen and (max-width: 1180.99px) {
			padding: 5px !important;
		}
		@media only screen and (max-width: 1023.99px) {
			padding: 30px !important;
		}

		@media only screen and (max-width: 991.99px) {
			padding: 24px !important;
		}
	} */
	ul.markData {
		margin: 0px;
		padding: 0px;
	}
	ul.markData li {
		display: list-item;
		list-style-type: none;
		padding-left: 10px;
		font-weight: 500;
		font-size: 14px;
		line-height: 32px;
		letter-spacing: -0.02em;
		color: #081d16;
		text-align: left;
		@media only screen and (max-width: 575.99px) {
			display: inline-block;
			margin-top: 30px;
		}
		@media only screen and (max-width: 445px) {
			margin-top: 5px;
		}
	}
	ul.markData li em {
		position: absolute;
		left: 0;
		margin-top: 10px;
		width: 10px;
		height: 10px;
		border-radius: 20px;
		@media only screen and (max-width: 575.99px) {
			position: relative;
			margin-top: 12px;
			margin-right: 5px;
			float: left;
		}
	}
	ul.markData li em.color1 {
		background: #1f9254;
	}
	ul.markData li em.color2 {
		background: #e5aa11;
	}
	ul.markData li em.color3 {
		background: #e53711;
	}
	ul.markData li em.color4 {
		background: #2f8dfa;
	}
	ul.markData li em.color5 {
		background: #1fd0bf;
	}
	ul.markData li em.color6 {
		background: #d5001a;
	}
`;
export const XThemeTableCharts = styled(Table)`
	position: relative;
	background: transparent;
	width: 100%;
	.ant-table-pagination.ant-pagination {
		margin: 15px 0px 0px 0px;
	}
	.ant-table-cell {
		font-style: normal;
		font-weight: 600;
		font-size: 12px;
		line-height: 16px;
		text-transform: uppercase;
		background: ${({ theme }) => theme.colors.bodyBg} !important;
		color: ${({ theme }) => theme.colors.themeColor4} !important;
		border-radius: 0px !important;
	}
	td.ant-table-cell {
		text-transform: capitalize;
		font-size: 14px;
		background: transparent !important;
		color: ${({ theme }) => theme.colors.themeColor5} !important;
		font-weight: normal;
	}
	ul.barGraph {
		width: 100%;
		position: relative;
		margin: 0px;
		padding: 0px;
		background: transparent;
		overflow: auto;
		border-radius: 20px;
		box-shadow: inset 0 0 15px 0 ${({ theme }) => theme.colors.bodyBg};
		color: ${({ theme }) => theme.colors.white};
		align-items: center;
	}
	ul.barGraph li {
		justify-content: center;
		align-items: center;
		list-style-type: none;
		display: flex !important;
		float: left;
		box-shadow: inset 0px 12px 25px 5px rgba(0, 0, 0, 0.1);
		animation: wave 2s linear alternate;
		transform: translate3d(0, 0, 0);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-weight: 600;
		font-size: 12px;
		height: 100% !important;
		height: 30px;
		line-height: 30px !important;
		/* vertical-align: middle; */
	}
	@keyframes wave {
		2% {
			transform: translateX(1);
		}

		25% {
			transform: translateX(-25%);
		}

		50% {
			transform: translateX(-50%);
		}

		75% {
			transform: translateX(-25%);
		}

		100% {
			transform: translateX(1);
		}
	}
	ul.barGraph li.step1 {
		background: ${({ theme }) => theme.colors.themeColor13};
		border-right: 1px solid ${({ theme }) => theme.colors.white};
	}
	ul.barGraph li.step2 {
		background: ${({ theme }) => theme.colors.themeColor12};
		border-right: 1px solid ${({ theme }) => theme.colors.white};
	}
	ul.barGraph li.step3 {
		background: ${({ theme }) => theme.colors.themeColor10};
	}
	ul.barGraph li.step4 {
		/* background: #3b82f6;
		border-right: 1px solid ${({ theme }) => theme.colors.white}; */
		background: ${({ theme }) => theme.colors.themeColor13};
		border-right: 1px solid ${({ theme }) => theme.colors.white};
	}
	ul.barGraph li.step5 {
		/* background: #19dae7;
		border-right: 1px solid ${({ theme }) => theme.colors.white}; */
		background: ${({ theme }) => theme.colors.themeColor12};
		border-right: 1px solid ${({ theme }) => theme.colors.white};
	}
	ul.barGraph li.step6 {
		/* background: #d5001a;
		border-right: 1px solid ${({ theme }) => theme.colors.white}; */
		background: ${({ theme }) => theme.colors.themeColor10};
	}
	ul.ant-pagination {
		margin: 15px 15px 0px 15px !important;
		li.ant-pagination-item,
		.ant-pagination-prev button,
		.ant-pagination-next button {
			background: ${({ theme }) => theme.colors.bodyBg};
			color: ${({ theme }) => theme.colors.themeColor24};
			border-radius: 50%;
			font-weight: 600;
			font-size: 13px;
			&:hover,
			&.ant-pagination-item-active {
				background: ${({ theme }) => theme.colors.themeColor8};
				color: ${({ theme }) => theme.colors.white} !important;
				border-color: ${({ theme }) => theme.colors.themeColor8};
			}
		}
		li.ant-pagination-disabled button {
			background: ${({ theme }) => theme.colors.themeColor22};
			color: ${({ theme }) => theme.colors.themeColor4};
			border-radius: 50%;
			font-weight: 600;
			font-size: 13px;
			&:hover {
				background: ${({ theme }) =>
					theme.colors.themeColor22} !important;
				color: ${({ theme }) => theme.colors.themeColor4};
				border-color: ${({ theme }) => theme.colors.themeColor22};
			}
		}
	}
`;
export const XThemeReimbursementCard = styled(Card)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.bodyBg} !important;
	border: 1px solid ${({ theme }) => theme.colors.themeColor23};
	border-radius: 15px;
	.ant-card-body {
		padding: 15px;
	}
	.cardTitle1 {
		margin: 0px;
		font-weight: 400;
		font-size: 16px;
		line-height: 20px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor2};
	}
	.cardTitle2 {
		margin: 0px;
		font-weight: 600;
		font-size: 20px;
		line-height: 20px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor2};
	}
`;
export const XThemePayersCard = styled(Card)`
	width: 100%;
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor23};
	border-radius: 20px;
	margin-bottom: 30px;
	.ant-card-body {
		padding: 15px !important;
		border-radius: 20px;
		border: none;
		@media only screen and (max-width: 768.99px) {
			padding: 15px !important;
		}
		.headerData {
			font-weight: 600;
			font-size: 18px;
			line-height: 22px;
			color: ${({ theme }) => theme.colors.themeColor5};
			span {
				font-weight: 500;
				font-size: 12px;
				line-height: 18px;
				letter-spacing: 0.03em;
			}
			.headerColor1 {
				color: ${({ theme }) => theme.colors.themeColor14};
				font-style: normal;
			}
			.headerColor2 {
				color: ${({ theme }) => theme.colors.themeColor15};
				font-style: normal;
			}
			.headerColor3 {
				color: ${({ theme }) => theme.colors.themeColor16};
				font-style: normal;
			}
			.headerColor4 {
				color: ${({ theme }) => theme.colors.themeColor17};
				font-style: normal;
			}
		}
		h6 {
			margin: 0px;
			font-weight: 600;
			font-size: 14px;
			line-height: 18px;
			letter-spacing: 0.03em;
			color: ${({ theme }) => theme.colors.themeColor5};
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		h5 {
			margin: 0px;
			font-weight: 500;
			font-size: 14px;
			line-height: 18px;
			display: flex;
			align-items: center;
			letter-spacing: 0.03em;
			color: ${({ theme }) => theme.colors.themeColor5};
		}
		h6.overallScoreList {
			padding: 8px 15px;
			font-weight: 400;
			font-size: 13px;
			line-height: 18px;
			letter-spacing: 0.03em;
			span {
				font-weight: 500;
				position: absolute;
				text-align: center;
				right: 15px;
				z-index: 1;
			}
		}
		h6.listColor2 {
			background-color: ${({ theme }) => theme.colors.themeColor20};
			background-image: -webkit-linear-gradient(
				180deg,
				${({ theme }) => theme.colors.themeColor18} 30%,
				${({ theme }) => theme.colors.themeColor20} 10%
			);
		}
		h6.listColor3 {
			background-color: ${({ theme }) => theme.colors.themeColor19};
			background-image: -webkit-linear-gradient(
				180deg,
				${({ theme }) => theme.colors.themeColor19} 30%,
				${({ theme }) => theme.colors.themeColor21} 10%
			);
		}
		h6.overallScoreList2 {
			display: flex;
			align-items: center;
			margin: 0px;
			padding: 20px 0px;
			font-weight: 500;
			font-size: 13px;
			line-height: 18px;
			letter-spacing: 0.03em;
			border-bottom: 1px dashed
				${({ theme }) => theme.colors.themeColor23};
			span {
				position: absolute;
				display: flex;
				align-items: center;
				justify-content: center;
				right: 0;
				width: 50px;
				height: 50px;
				line-height: 25px;
				border-radius: 30px;
				text-align: center;
				font-weight: 600;
				font-size: 10px;
				letter-spacing: 0.03em;
				color: ${({ theme }) => theme.colors.white};
				@media only screen and (max-width: 991.99px) {
					width: 40px;
					height: 40px;
					font-weight: 400;
					line-height: 40px;
				}
			}
			.dashboard-tooltip-css {
				height: auto;
				position: relative;
				color: black;
				display: block;
				width: auto;
				margin: 0px 3px;
			}
			.list2Color1 {
				background: ${({ theme }) => theme.colors.themeColor14};
			}
			.list2Color2 {
				background: ${({ theme }) => theme.colors.themeColor15};
			}
			.list2Color3 {
				background: ${({ theme }) => theme.colors.themeColor16};
			}
			.list2Color4 {
				background: ${({ theme }) => theme.colors.themeColor17};
			}
		}
	}
`;
export const XThemeReactSpeedometer = styled(ReactSpeedometer)`
	width: 100%;
	position: relative;
`;
export const XThemeModalAnimation = styled(Modal)`
	.ant-modal-close {
		top: -5px !important;
		inset-inline-end: 0px !important;
		display: none;
	}
	.ant-card {
		border: none;
		background: transparent;
		box-shadow: none;
	}
	.ant-modal-footer {
		margin: 0px;
	}
	.ant-modal-content {
		background: transparent !important;
		box-shadow: none;
		padding: 80px 60px;
		@media only screen and (max-width: 511.99px) {
			padding: 15px !important;
		}
		&:after {
			position: absolute;
			left: 39%;
			right: 0;
			top: 45px;
			content: '';
			display: block;
			width: 114px;
			height: 51px;
			background: url('/images/loader_pin.svg') no-repeat center top;
			@media only screen and (max-width: 511.99px) {
				top: -20px;
				left: 30%;
			}
		}
	}
	.ant-card-body {
		background: #fff;
		border-radius: 40px;
		border: 15px solid rgba(2, 117, 155, 0.1);
		ul {
			margin: 0px;
			padding: 0px;
			min-height: 285px;
		}
		ul li {
			display: list-item;
			list-style-type: none;
			font-weight: 500;
			font-size: 14px;
			line-height: 30px;
			margin-bottom: 30px;
			padding-left: 40px;
			@media only screen and (max-width: 511.99px) {
				line-height: 16px;
			}
			&:last-child {
				margin-bottom: 0px;
			}
			span {
				position: absolute;
				left: 30px;
				width: 30px;
				height: 30px;
				border-radius: 30px;
				text-align: center;
				@media only screen and (max-width: 511.99px) {
					line-height: 30px;
				}
			}
		}
		ul li.active {
			color: #008542;
			transition: color 3s;
			span {
				background: #008542;
				transition: background-color 3s;
			}
		}
		ul li.inprocess {
			color: #e5aa11;
			transition: color 3s;
			span {
				background: #e5aa11;
				transition: background-color 3s;
			}
		}

		.laser {
			width: 115%;
			margin-left: -15%;
			background-color: rgba(2, 117, 155, 0.1);
			border-radius: 10px;
			height: 1px;
			position: absolute;
			height: 10px;
			top: 3%;
			z-index: 3;
			-webkit-animation: scanning 5s infinite;
			-moz-animation: scanning 5s infinite;
			animation: scanning 5s infinite;
		}

		@keyframes scanning {
			50% {
				-webkit-transform: translateY(370px);
				-moz-transform: translateY(370px);
				transform: translateY(370px);
			}
		}
	}
`;
export const XThemeLottieLoader = styled.section`
	width: 100%;
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	right: 0;
	top: 20px;
	bottom: 0;
`;
export const XThemeCreateCaseBtn = styled(Button)`
	background: ${({ theme }) => theme.colors.white};
	box-shadow: 0px 4px 4px rgba(0, 114, 153, 0.2) !important;
	border-radius: 25px !important;
	font-weight: 500;
	font-size: 14px;
	line-height: 16px;
	text-align: center;
	padding: 10px 25px !important;
	color: ${({ theme }) => theme.colors.themeColor8};
	height: auto !important;
	&:hover,
	&:active {
		background: ${({ theme }) => theme.colors.themeColor8} !important;
		color: ${({ theme }) => theme.colors.white} !important;
	}

	@media only screen and (max-width: 768px) {
		padding: 15px !important;
	}
`;
// End new theme style components
